import { useMemo } from "react";
import { get } from "lodash";
import { buildDescription, buildDetails } from "../ContentBuilder";
import { BetaFeatureInfoProps, BetaFeatureInformation } from "./types";

export const useBetaFeatureInfo = ({
  selectedFeature,
  isUserEnrolled,
  betaFeatures,
  noFeaturesAvailable
}: BetaFeatureInfoProps) =>
  useMemo(() => {
    if (noFeaturesAvailable) {
      return {};
    }

    const selectedBetaFeature = get(betaFeatures, selectedFeature);

    if (!selectedBetaFeature) {
      return {};
    }

    const betaFeatureInformation: BetaFeatureInformation = get(
      betaFeatures,
      `${selectedFeature}.${!isUserEnrolled ? "enroll" : "unroll"}`
    );
    const previewDescription = get(betaFeatureInformation, "description");
    const previewDetails = get(betaFeatureInformation, "details[0]");
    const confirmation = get(selectedBetaFeature, "exit");
    const confirmationDescription = get(confirmation, "description");

    const welcome = get(selectedBetaFeature, "welcome");

    return {
      welcome: {
        title: welcome?.title,
        subtitle: welcome?.subtitle,
        description: buildDescription(welcome?.description)
      },
      confirmation: {
        title: confirmation?.title,
        subtitle: confirmation?.subtitle,
        description: buildDescription(confirmationDescription)
      },
      preview: {
        description: buildDescription(previewDescription),
        details: buildDetails(previewDetails)
      }
    };
  }, [noFeaturesAvailable, selectedFeature, betaFeatures, isUserEnrolled]);
